var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{directives:[{name:"highlightjs",rawName:"v-highlightjs",value:(_vm.cssCode),expression:"cssCode"}],staticClass:"overflow-y-auto h-full px-5 w-full"},[_vm._v("      "),_c('code',{staticClass:"css vs -mt-6"}),_vm._v("\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }